export enum MerchantToolType {
  AREA_MIGRATION = 'AREA_MIGRATION_TOOL',
  TABLE_MIGRATION = 'TABLE_MIGRATION_TOOL',
  RESERVATION_REPORT = 'RESERVATION_REPORT_TOOL',
  INTEGRATION_MIGRATION = 'INTEGRATION_MIGRATION_TOOL'
}



// WEBPACK FOOTER //
// ./src/app/merchant-tools/models/merchant-tool-type.ts